var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKnowledgeBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F7",
    fillRule: "nonzero",
    d: "M25.6874531,16.5000179 C25.6874531,21.8514532 21.3498474,26.1874948 15.9999762,26.1874948 C10.6501049,26.1874948 6.31249925,21.8514532 6.31249925,16.5000179 C6.31249925,11.1517106 10.6501049,6.81254098 15.9999762,6.81254098 C21.3498474,6.81254098 25.6874531,11.1517106 25.6874531,16.5000179 Z M16.2599472,10.0156583 C14.1311604,10.0156583 12.7734366,10.9124152 11.7072694,12.506192 C11.5691396,12.712681 11.6153354,12.9911533 11.8133177,13.1412612 L13.1687146,14.1690145 C13.3720375,14.3232042 13.6617249,14.2865069 13.8196911,14.0861214 C14.517512,13.2010374 14.9959884,12.6878093 16.058112,12.6878093 C16.8561066,12.6878093 17.8431572,13.2013807 17.8431572,13.9752284 C17.8431572,14.5602108 17.3602558,14.8606556 16.572332,15.3023965 C15.6534117,15.817532 14.4374799,16.4586667 14.4374799,18.0625142 L14.4374799,18.2187638 C14.4374799,18.4776285 14.647364,18.6875127 14.9062288,18.6875127 L17.0937236,18.6875127 C17.3525883,18.6875127 17.5624724,18.4776285 17.5624724,18.2187638 L17.5624724,18.1666933 C17.5624724,17.0549024 20.8119001,17.0085921 20.8119001,14.0000238 C20.8119001,11.7343279 18.461747,10.0156583 16.2599472,10.0156583 Z M15.9999762,19.7031352 C15.0091491,19.7031352 14.2031054,20.5091789 14.2031054,21.500006 C14.2031054,22.4907949 15.0091491,23.2968767 15.9999762,23.2968767 C16.9908033,23.2968767 17.7968469,22.4907949 17.7968469,21.500006 C17.7968469,20.5091789 16.9908033,19.7031352 15.9999762,19.7031352 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBase);
export default __webpack_public_path__ + "static/media/knowledge-base.bb8c072d.svg";
export { ForwardRef as ReactComponent };